import {ColumnDescription} from '../ColumnDescription';
import {asString} from '../../../../../../common/helpers/converters/asString';

export type SortDirection = 'asc' | 'desc';

export type SortState = {
    key: string,
    direction: SortDirection
}

export function getSortKey<T>(column: ColumnDescription<T>, columnIdx: number): string {
    return column.sortKey
        ?? (column.name !== undefined ? asString(column.name) : undefined)
        ?? column.header
        ?? `column-${columnIdx}`;
}

/**
 * Cycles sorting of a column between ascending and descending. Sorting is never turned off,
 * so a sorted column stays sorted no matter how many times it is clicked.
 */
export function nextSortState(current: SortState | undefined, key: string): SortState {
    return current?.key === key && current.direction === 'asc'
        ? {key, direction: 'desc'}
        : {key, direction: 'asc'};
}
